/* FORGE Klaviyo init — runs as a DEFERRED external script placed immediately after the
   deferred onsite.js tag. Deferred external scripts execute in document order, so the
   onsite library is guaranteed to be loaded before this runs — the same ordering
   guarantee the old synchronous load provided, without blocking the parser (the sync
   load was the #1 simulated-LCP cost in Lighthouse). Config comes from the JSON block
   rendered by snippets/forge-integrations.liquid. */
(function () {
  'use strict';
  var cfgEl = document.getElementById('forge-klaviyo-config');
  if (!cfgEl) { return; }
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!cfg.account) { return; }
  window.klaviyo = window.klaviyo || [];
  if (typeof window.klaviyo.init !== 'function') { return; }
  window.klaviyo.init({ account: cfg.account, platform: 'shopify' });
  if (cfg.bis) {
    window.klaviyo.enable('backinstock', {
      trigger: {
        product_page_text: 'Notify Me When Back In Stock',
        /* 2026-08-14 — this class is a DUMPING GROUND, deliberately.
           `product_page_class` does NOT name an element Klaviyo fills; Klaviyo creates its
           own element with this class and inserts it beside the first
           `form[action*="/cart/add"]` in the DOM. On this theme that is the cart drawer's
           upsell slot (the layout renders it before the main content), so the auto-injected
           button landed inside the drawer — an empty 180x59 anchor no shopper would ever
           find — while the PDP's `.forge-bis-anchor` stayed empty and sold-out products
           offered no notify path at all. The PDP now renders a real `.klaviyo-bis-trigger`
           of its own (sections/forge-pdp.liquid); Klaviyo's delegated click handler drives
           it just the same. This class exists only so the automatic element has somewhere
           harmless to go — forge.css hides it. */
        product_page_class: 'forge-bis-auto',
        product_page_text_align: 'center',
        product_page_margin: '0px',
        replace_anchor: false
      },
      modal: {
        headline: '{product_name}',
        body_content: 'Enter your email to be notified when this item is back in stock.',
        email_field_label: 'Email',
        button_label: 'Notify Me When Back In Stock',
        subscription_success_label: "You're in! We'll let you know when it's back.",
        footer_content: '',
        drop_background_color: '#0c0a09',
        background_color: '#16120f',
        text_color: '#efeae3',
        button_text_color: '#160a05',
        button_background_color: '#ed8a45',
        close_button_color: '#948e86',
        error_background_color: '#fcd6d7',
        error_text_color: '#C72E2F',
        success_background_color: '#d3efcd',
        success_text_color: '#1B9500'
      }
    });
  }
})();
